import React from "react";
import styled from "styled-components";

export const Row = styled.div`
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
`;

export const LeftImage = styled.img`
    height: 383px;
    width: 588px;
    margin-right: 20px;
    margin-top: 75px;
    @media (max-width: 767px){
        height: 279px;
        width: auto;
        margin: 0;
    }
`;

export const RightImage = styled.img`
    height: 555px;
    width: 394px;
    margin-left: 20px;
    @media (max-width: 767px){
        height: 339px;
        width: auto;
        margin: 30px 0 0 0;
    }
`;

export const Container = styled.div`
	margin: ${props => props.theme.spacing};
	max-width: ${props => props.theme.max};
    @media(max-width: 767px){
		margin:  ${(props) => props.theme.mobileSpacing};
	}
`;